<template>
    <hm-content title="">
      <div class="table-panel flex flex-between">
        <button style="opacity: 0;"></button>
        <div class="flex item-center">
          <el-select
              size="small"
              clearable
              placeholder="是否是直营店"
              v-model="joinType"
              class="mr10"
              filterable
          >
            <el-option label="是" value="self"></el-option>
            <el-option label="否" value="join"></el-option>
          </el-select>
          <!-- <el-select
            size="small"
            clearable
            placeholder="是否接微店订单"
            v-model="isAccept"
            class="mr10"
            filterable
          >
            <el-option label="是" value="yes"></el-option>
            <el-option label="否" value="no"></el-option>
          </el-select> -->
          <el-input
            clearable
            v-model.trim="keyWords"
            placeholder="请输入关键词/商店名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <!-- <el-cascader
            clearable
            style="margin-right: 10px"
            ref="cascader"
            v-model="departId"
            :props="props"
            :show-all-levels="false"
            size="small"
            placeholder="请选择机构"
          ></el-cascader> -->
          <el-button type="primary" size="small" @click="search">查询</el-button>
        </div>
      </div>
      
      <el-table
        :data="shopList.records"
        stripe
        border
        lazy
        style="width: 100%"
        size="small"
        @selection-change="handleSelectionChange"
      >
      
      <el-table-column
        type="selection"
        width="55"
        >
      </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="编号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>

        <el-table-column
          prop="shopCode"
          label="商店编号"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="shopName"
          label="商店名称"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="shopPhone"
          label="电话"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="realname"
          label="联系人/职员"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系人电话"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="shopAddress"
          label="地址"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.shopAddress }}{{ scope.row.shopDetailAddress }}
          </template>
        </el-table-column>
        <el-table-column
          prop="syncFlag"
          label="是否实体店"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.syncFlag === "hemiao" ? "虚拟店" : "实体店"
            }}</span>
            <span></span>
          </template>
        </el-table-column>
        <el-table-column
          prop="shopImg"
          label="门店图片"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.shopImg"
              style="width: 100px; height: 100px"
              :src="scope.row.shopImg"
              :preview-src-list="[scope.row.shopImg]"
            >
            </el-image>
            <div v-else>未维护</div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="departName"
          label="所属机构"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="derportList"
          label="关联仓库"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span v-for="(item, i) in scope.row.derportList" :key="i">{{
              item ? item.depotName : item
            }}</span>
          </template>
        </el-table-column> -->


      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="shopList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :page-sizes="[10, 50, 100, 200]"
          layout="total,  prev, pager, next, jumper, sizes"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
      <el-dialog
        :close-on-click-modal="false"
        :title="title"
        :visible.sync="dialogVisible"
        width="70%"
      >
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item label="商店编号" prop="shopCode">
            <el-input
              :disabled="disabled"
              clearable
              v-model="ruleForm.shopCode"
              maxlength="20"
              size="small"
              placeholder="请输入商店编号"
            ></el-input>
          </el-form-item>
          <el-form-item label="商店名称" prop="shopName">
            <el-input
              :disabled="!shopNameEdit"
              clearable
              v-model="ruleForm.shopName"
              maxlength="20"
              size="small"
              placeholder="请输入商店名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="shopPhone">
            <el-input
              clearable
              v-model="ruleForm.shopPhone"
              maxlength="20"
              size="small"
              placeholder="请输入商城电话"
            ></el-input>
          </el-form-item>
  
          <el-form-item label="商店联系人" prop="employeeId">
            <el-select
              filterable
              clearable
              v-model="ruleForm.employeeId"
              value-key="shopId"
              placeholder="请选择商店联系人"
              size="small"
            >
              <el-option
                v-for="(item, i) in employeeList"
                :key="i"
                :label="item.realname"
                :value="item.employeeId"
              >
              </el-option>
            </el-select>
          </el-form-item>
  
          <el-form-item label="所属机构" prop="departInfoModelLists">
            <el-cascader
              ref="cascader"
              v-model="ruleForm.departInfoModelLists"
              :props="props"
              :show-all-levels="false"
              size="small"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="关联仓库" prop="derportLists">
            <el-select
              filterable
              v-model="ruleForm.derportLists"
              value-key="id"
              multiple
              placeholder="请选择"
            >
              <el-option
                v-for="(item, i) in depotList"
                :key="i"
                :label="item.depotName"
                :value="item.depotId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="门店群二维码" prop="qrCode">
            <el-upload
              class="avatar-uploader flex mb20"
              ref="upload"
              :data="{ fileDir: 'mall' }"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :on-remove="handleRemove2"
              :onError="uploadError"
              :onSuccess="cropUploadSuccess2"
              :beforeUpload="beforeAvatarUpload"
              :onProgress="uploading"
              :show-file-list="false"
              :on-change="handleChange2"
            >
              <div v-if="ruleForm.qrCode" class="flex item-end priview">
                <img
                  :src="ruleForm.qrCode"
                  style="width: 360px; height: 180px"
                  alt="logo"
                />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="handleRemove2">删除</el-button>
                </div>
              </div>
  
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div class="el-upload__tip ml10" slot="tip">
                <span class="mr">
                  上传图片注意：
                  <br />1.建议上传企业微信群活码
                  <br />2.图片格式：只能上传jpg/png文件
                </span>
                <el-progress
                  v-if="progressFlag2"
                  :percentage="loadProgress"
                ></el-progress>
              </div>
            </el-upload>
  
            <span class="mr20">二维码标题</span>
            <el-input
              class="mr20"
              clearable
              v-model="ruleForm.description"
              maxlength="4"
              size="small"
              placeholder="请输入标题，限制4个字内"
            ></el-input>
  
            <el-switch
              v-model="ruleForm.isShow"
              active-color="#2d8"
              inactive-color="#ff4949"
              active-text="显示"
              inactive-text="关闭"
              :active-value="true"
              :inactive-value="false"
            ></el-switch>
          </el-form-item>
  
          <el-form-item label="门店图片" prop="shopImg">
            <el-upload
              class="avatar-uploader flex"
              ref="upload"
              :data="{ fileDir: 'mall' }"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :on-remove="handleRemove"
              :onError="uploadError"
              :onSuccess="cropUploadSuccess"
              :beforeUpload="beforeAvatarUpload"
              :onProgress="uploading"
              :show-file-list="false"
              :on-change="handleChange"
            >
              <div v-if="ruleForm.shopImg" class="flex item-end priview">
                <img
                  :src="ruleForm.shopImg"
                  style="width: 360px; height: 180px"
                  alt="logo"
                />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="handleRemove">删除</el-button>
                </div>
              </div>
  
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div class="el-upload__tip ml10" slot="tip">
                <span class="mr">
                  上传图片注意：
                  <!-- <br />1.建议图片尺寸为690x260像素的png图 -->
                  <br />1.图片格式：只能上传jpg/png文件
                </span>
                <el-progress
                  v-if="progressFlag"
                  :percentage="loadProgress"
                ></el-progress>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="所在省市区" prop="citys">
            <el-cascader
              :options="area"
              size="small"
              ref="citys"
              clearable
              placeholder="请选择省市区"
              v-model="ruleForm.citys"
              :props="propCitys"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="定位地址" prop="shopAddress">
            <el-input
              style="width: 300px"
              disabled
              clearable
              v-model="ruleForm.shopAddress"
              size="small"
              placeholder="已选中的地址"
            ></el-input>
            <div class="flex flex-wrap mt10">
              <div class="flex flex-end mr10">详细地址</div>
              <el-input
                type="textarea"
                style="width: 235px"
                clearable
                v-model="ruleForm.shopDetailAddress"
                size="small"
                placeholder="请输入详细地址"
              ></el-input>
            </div>
          </el-form-item>
          <!-- 通过 iframe 嵌入地图选点组件 -->
          <div style="marginleft: 100px">
            <map-picker
              :visible="dialogVisible"
              height="500px"
              width="500px"
              @locationSelect="handleLocationSelect"
            />
          </div>
          <el-form-item label="备注" label-width="107px" prop="remarks">
            <el-input
              clearable
              v-model="ruleForm.remarks"
              maxlength="50"
              size="small"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
  
          <el-form-item label="微店订单" label-width="107px" prop="isAccept">
            <el-select v-model="ruleForm.isAccept" placeholder="请选择是否开启">
              <el-option label="开启" value="yes"> </el-option>
              <el-option label="关闭" value="no"> </el-option>
            </el-select>
          </el-form-item>
  
          <el-form-item label="是否是直营店" label-width="107px" prop="joinType">
            <el-select v-model="ruleForm.joinType" placeholder="是否是直营店">
              <el-option label="是" value="self"> </el-option>
              <el-option label="否" value="join"> </el-option>
            </el-select>
            <el-button @click="showPayInfo" class="ml10" type="primary" size="small" v-show="ruleForm.joinType==='join'">查看支付绑定信息</el-button>
          </el-form-item>
  
          <el-form-item label="服务人员" v-if="theAttendantPullsDown.length>0" label-width="107px" prop="serviceStaff">
            <el-select v-model="ruleForm.serviceStaff" placeholder="请选择服务人员">
              <el-option v-for="item in theAttendantPullsDown" :key="item.staffPhone" :label="item.staffName" :value="item.staffName"> </el-option>
            </el-select>
          </el-form-item>
  
        </el-form>
       
  
        <div class="btn-wrapper flex flex-center">
          <el-button size="small" type="primary" @click="save">确 定</el-button>
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>
  
        <el-dialog
          title='支付商户号信息'
          :visible.sync='detailVisible'
          width='600px'
          :show-close='false'
          :close-on-click-modal='false'
          :close-on-press-escape='false'
          destroy-on-close
          custom-class='common-dialog'
        >
          <el-table :data="payInfoList">
            <el-table-column label="营业执照号" prop="registrationNumber"></el-table-column>
            <el-table-column label="营业执照名称" prop="businessPermitTitle"></el-table-column>
            <el-table-column label="收款账户名称" prop="bankReceivingAccountName"></el-table-column>
            <el-table-column label="收款账户号" prop="bankAccountNumber"></el-table-column>
          </el-table>
          <template slot='footer'>
            <el-button @click='detailVisible = false' type='primary' size='small'>确定</el-button>
          </template>
        </el-dialog>
  
      <el-dialog
        :close-on-click-modal="false"
        title="配送管理"
        :visible.sync="dialogDistributionVisible"
      >
        <el-dialog
          width="900px"
          :title="threeDialogTitle"
          :visible.sync="innerThreeVisible"
          append-to-body
        >
          <div class="flex flex-around">
            <el-form
              ref="ruleFormThree"
              :model="ruleFormThree"
              :rules="rulethree"
              label-width="110px"
            >
              <el-form-item label="三方平台选择" prop="thirdExpressId">
                <el-select
                  clearable
                  size="small"
                  v-model="ruleFormThree.thirdExpressId"
                  placeholder="请选择三方平台"
                >
                  <el-option
                    v-for="(v, i) in thirdExpressInfoList"
                    :key="i"
                    :label="v.thirdInterfaceName"
                    :value="v.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="门店名称" prop="">
                {{ shopName }}
              </el-form-item>
              <el-form-item label="门店业务类型" prop="business">
                <el-select
                  clearable
                  size="small"
                  filterable
                  v-model="ruleFormThree.business"
                  placeholder="请选择门店业务类型"
                >
                  <el-option
                    v-for="(v, i) in businessTypeList"
                    :key="i"
                    :label="v.name"
                    :value="v.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所在省市区" prop="citys">
                <el-cascader
                  :options="area"
                  size="small"
                  ref="citys"
                  clearable
                  placeholder="请选择省市区"
                  v-model="ruleFormThree.citys"
                  :props="propCitys"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="定位地址" prop="shopAddress">
                <el-tooltip
                  class="item"
                  :disabled="!ruleFormThree.shopAddress"
                  effect="dark"
                  :content="ruleFormThree.shopAddress"
                  placement="top-start"
                >
                  <el-input
                    style="width: 300px"
                    clearable
                    readonly
                    v-model="ruleFormThree.shopAddress"
                    size="small"
                    placeholder="请在右侧选择定位地址"
                  ></el-input>
                </el-tooltip>
                <div class="flex flex-wrap mt10">
                  <div class="flex flex-end mr10">详细地址</div>
                  <el-input
                    type="textarea"
                    style="width: 235px"
                    clearable
                    v-model="ruleFormThree.shopDetailAddress"
                    size="small"
                    placeholder="请输入详细地址"
                  ></el-input>
                </div>
              </el-form-item>
              <el-form-item label="电话" prop="shopPhone">
                <el-input
                  type="number"
                  style="width: 300px"
                  clearable
                  v-model="ruleFormThree.shopPhone"
                  maxlength="20"
                  size="small"
                  placeholder="请输入电话"
                ></el-input>
              </el-form-item>
              <el-form-item label="商店联系人" prop="realname">
                <el-select
                  filterable
                  clearable
                  style="width: 300px"
                  v-model="ruleFormThree.realname"
                  value-key="shopId"
                  size="small"
                  placeholder="请选择商店联系人"
                >
                  <el-option
                    v-for="(item, i) in employeeList"
                    :key="i"
                    :label="item.realname"
                    :value="item.realname"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="threeDialogTitle === '注册三方平台信息'"
                prop="checked"
                style="margin-left: -110px"
                class="flex flex-center"
              >
                <el-checkbox v-model="ruleFormThree.checked"
                  >我同意并准守</el-checkbox
                >
                <el-link :underline="true" type="primary"
                  >《代发三方平台服务规范》</el-link
                >
              </el-form-item>
            </el-form>
            <div>
              <div class="title">选择定位地址</div>
              <map-picker
                :visible="innerThreeVisible"
                height="500px"
                width="400px"
                @locationSelect="handleLocationSelect"
              />
            </div>
          </div>
  
          <div slot="footer" class="dialog-footer flex flex-center">
            <el-button
              type="primary"
              size="small"
              @click="submitFormThree('ruleFormThree')"
              >保存</el-button
            >
            <el-button
              @click="innerThreeVisible = false"
              type="primary"
              size="small"
              >关闭</el-button
            >
          </div>
        </el-dialog>
        <el-form
          ref="ruleDistributionForm"
          :model="ruleDistributionForm"
          :rules="rulesDistribution"
          label-width="110px"
        >
          <el-form-item label="配送方式" prop="expressItems">
            <!-- <el-checkbox-group> -->
            <!-- <el-checkbox
                v-for="(v, i) in mode2List"
                :key="i"
                :label="v.itemValue"
                >{{ v.itemText }}</el-checkbox
              > -->
  
            <el-checkbox
              v-model="ruleDistributionForm.shopExtract"
              true-label="yes"
              false-label="no"
              >门店自提</el-checkbox
            >
            <div>
              <el-checkbox
                v-model="ruleDistributionForm.expressDelivery"
                true-label="yes"
                false-label="no"
                >快递配送</el-checkbox
              >
              <div style="marginleft: 20px">
                <el-radio-group
                  v-model="ruleDistributionForm.expressAreaMode"
                  @change="ruleDistributionFormChange"
                >
                  <el-radio label="all">全部区域</el-radio>
                  <el-radio label="target">指定区域</el-radio>
                  <el-button
                    v-if="ruleDistributionForm.expressAreaMode === 'target'"
                    type="primary"
                    plain
                    size="small"
                    @click="addAssign"
                    >指定区域</el-button
                  >
                </el-radio-group>
              </div>
            </div>
  
            <el-checkbox
              v-model="ruleDistributionForm.localDelivery"
              true-label="yes"
              false-label="no"
              >同城配送</el-checkbox
            >
            <div class="ml20" v-if="ruleDistributionForm.localDelivery === 'yes'">
              <el-checkbox
                v-model="ruleDistributionForm.isThreeDelivery"
                true-label="yes"
                false-label="no"
                >三方平台配送</el-checkbox
              >
              <div v-if="ruleDistributionForm.isThreeDelivery === 'yes'">
                <el-button size="small" type="primary" @click="openThree">{{
                  threeDialogTitle
                }}</el-button>
              </div>
            </div>
          </el-form-item>
  
          <el-form-item
            label="配送范围"
            prop="areaCodeRegion"
            v-show="ruleDistributionForm.localDelivery === 'yes'"
          >
            <div style="width: 500px; height: 400px" id="containers"></div>
          </el-form-item>
          <div class="flex flex-center">
            <el-button
              type="primary"
              size="small"
              @click="submitForm('ruleDistributionForm')"
              >保存</el-button
            >
            <el-button size="small" @click="dialogDistributionVisible = false"
              >关闭</el-button
            >
          </div>
        </el-form>
      </el-dialog>
      <el-dialog
        title="选择快递配送区域"
        width="70%"
        :close-on-click-modal="false"
        :visible.sync="dialogAssignVisible"
      >
        <el-table
          stripe
          border
          class="mb20"
          ref="brandTable"
          @selection-change="getMicroChecked"
          :data="expressListAll.records"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            :index="
              (index) => index + (expressCurrentPage - 1) * expressPageSize + 1
            "
          ></el-table-column>
          <el-table-column
            prop="expressName"
            label="快递配送名称"
            header-align="center"
            align="center"
          >
          </el-table-column>
  
          <el-table-column
            prop="feeCalcMode"
            label="费用计算方式"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.feeCalcMode === 'number'"
                >按商品件数计算</span
              >
              <span v-else>按重量计算</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="lowerLimitAmount"
            label="首件/首重费用"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span
                >首{{ scope.row.lowerLimitNumber
                }}{{ scope.row.feeCalcMode === "number" ? "件" : "kg" }},邮费{{
                  scope.row.lowerLimitExpressyFee
                }}元</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="overPerPrice"
            label="续重/续件费用"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span
                >续重每1{{
                  scope.row.feeCalcMode === "number" ? "件" : "kg"
                }},加邮费{{ scope.row.overPerPrice }}元</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="freeShipAmount"
            label="满额免邮"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>满{{ scope.row.freeShipAmount }}元包邮</span>
            </template>
          </el-table-column>
  
          <el-table-column
            prop="enabledState"
            label="开启状态"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span
                :class="scope.row.enabledState === 'yes' ? 'success' : 'danger'"
                >{{ scope.row.enabledState === "yes" ? "开启" : "关闭" }}</span
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="expressListAll.total"
            @current-change="expressPaging"
            @size-change="expressSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="expressCurrentPage"
          ></el-pagination>
        </div>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="batchAffirm"
            >确认</el-button
          >
          <el-button size="small" @click="dialogAssignVisible = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
    </hm-content>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import { setCookie, getCookie } from "@/utils/utils";
  import area from "@/utils/area";
  import { getLoginUser } from "@/utils/auth";
  import MapPicker from "@/components/MapPicker/MapPicker";
  export default {
    components: { MapPicker },
    props:{
      checkOutTheStoreData: {
        type: Object,
        default: false
      },
    },
    data() {
      const patternCitys = (rule, val, callback) => {
        if (!val.length) {
          return callback(new Error("请选择省市区"));
        }
        callback();
      };
      const patternChecked = (rule, val, callback) => {
        if (!val) {
          return callback(new Error("请先勾选同意"));
        }
        callback();
      };
      const patternPhoneLocation = function(rule, val, callback) {
        let haveEmptyCondition = false;
  
        const reg = /[\u4E00-\u9FA5]/g;
        if (!this.ruleForm.shopPhone) {
          haveEmptyCondition = true;
        } else {
          if (reg.test(this.ruleForm.shopPhone)) {
            haveEmptyCondition = true;
          }
        }
  
        if (haveEmptyCondition) {
          return callback(new Error("请填写电话"));
        }
        callback();
      }.bind(this);
      const patternLocation = function(rule, val, callback) {
        let haveEmptyCondition = false;
  
        const reg = /[\u4E00-\u9FA5]/g;
        if (!this.ruleForm.shopCode) {
          haveEmptyCondition = true;
        } else {
          if (reg.test(this.ruleForm.shopCode)) {
            haveEmptyCondition = true;
          }
        }
  
        if (haveEmptyCondition) {
          return callback(
            new Error("编号为唯一值，仅支持英文和数字，不支持汉字")
          );
        }
        callback();
      }.bind(this);
      const patternExpress = function(rule, val, callback) {
        if (
          this.ruleDistributionForm.shopExtract === "no" &&
          this.ruleDistributionForm.expressDelivery === "no" &&
          this.ruleDistributionForm.localDelivery === "no"
        ) {
          return callback(new Error("请选择配送方式"));
        } else {
          if (this.ruleDistributionForm.expressDelivery === "yes") {
            if (this.ruleDistributionForm.expressAreaMode === "target") {
              if (this.checkedMicroRow.length < 1) {
                return callback(new Error("请选择指定配送区域"));
              } else if (this.ruleDistributionForm.expressDelivery === "no") {
                return callback(new Error("请选择配送方式"));
              }
            }
          }
          if (
            this.ruleDistributionForm.localDelivery === "yes" &&
            this.ruleDistributionForm.isThreeDelivery === "yes"
          ) {
            if (!this.ruleDistributionForm.thirdCode) {
              return callback(new Error("请先注册三方平台"));
            }
          }
        }
  
        callback();
      }.bind(this);
      return {
        shopList:[],
        theAttendantPullsDown:[],
        threeDialogTitle: "",
        businessTypeList: [
          {
            name: "食品小吃",
            value: "1",
          },
          {
            name: "饮料",
            value: "2",
          },
          {
            name: "文印票务",
            value: "8",
          },
          {
            name: "便利店",
            value: "9",
          },
          {
            name: "水果生鲜",
            value: "13",
          },
          {
            name: "同城电商",
            value: "19",
          },
          {
            name: "医药",
            value: "20",
          },
          {
            name: "蛋糕",
            value: "21",
          },
          {
            name: "酒品",
            value: "24",
          },
          {
            name: "小商品市场",
            value: "25",
          },
          {
            name: "服装",
            value: "26",
          },
          {
            name: "汽修零配",
            value: "27",
          },
          {
            name: "数码",
            value: "28",
          },
          {
            name: "小龙虾",
            value: "29",
          },
          {
            name: "火锅",
            value: "51",
          },
          {
            name: "其他",
            value: "-5",
          },
        ],
        shopName: "",
        ruleFormThree: {
          thirdExpressId: "",
          shopId: "",
          shopName: "",
          business: "",
          realname: "",
          shopAddress: "",
          shopDetailAddress: "",
          longitude: "",
          dimension: "",
          citys: [],
          shopPhone: "",
          shopProvinceCode: "",
          shopCityCode: "",
          shopDistrictCode: "",
          checked: false,
        },
        rulethree: {
          thirdExpressId: {
            required: true,
            trrger: "blur",
            message: "请选择三方平台选择",
          },
          business: {
            required: true,
            trrger: "blur",
            message: "请选择门店业务类型",
          },
          citys: {
            required: true,
            validator: patternCitys,
          },
          realname: {
            required: true,
            trrger: "blur",
            message: "请选择商店联系人",
          },
          shopAddress: {
            required: true,
            trrger: "blur",
            message: "请选择定位地址",
          },
          shopPhone: [
            {
              required: true,
              trrger: "blur",
              message: "请输入电话",
            },
            {
              required: true,
              pattern: /^1[0-9]{10}$/,
              message: "请输入正确的手机号",
              trigger: "blur",
            },
          ],
          checked: {
            required: true,
            validator: patternChecked,
          },
        },
        innerThreeVisible: false,
        loadProgress: 0, // 动态显示进度条
        progressFlag: false, // 关闭进度条
        progressFlag2: false,
        uploadShow: true,
        isSaving: false,
        area,
        queryKey: "",
        shopId: "",
        isAccept: "",
        joinType: "",
        depotList: [],
        employeeList: [],
        departId: [],
        checkedMicroRow: [],
        keyWords: "",
        title: "",
        pageSize: 10,
        currentPage: 1,
        expressPageSize: 10,
        expressCurrentPage: 1,
        disabled: false,
        shopNameEdit: false,
        dialogVisible: false,
        dialogDistributionVisible: false,
        dialogAssignVisible: false,
        ruleDistributionForm: {
          shopExtract: "",
          expressDelivery: "",
          expressIds: [],
          expressAreaMode: "",
          localDelivery: "",
          areaCodeCenter: "",
          areaCodeRadius: "",
          isThreeDelivery: "no",
        },
        rulesDistribution: {
          expressItems: [
            {
              required: true,
              trrger: "blur",
              validator: patternExpress,
            },
          ],
        },
        ruleForm: {
          shopCode: "",
          shopName: "",
          shopPhone: "",
          phone: "",
          remarks: "",
          derportLists: [],
          employeeId: "",
          isAccept: "",
          serviceStaff:'',
          shopAddress: "",
          shopDetailAddress: "",
          longitude: "",
          dimension: "",
          shopImg: "",
          qrCode: "",
          description: "",
          isShow: true,
          departInfoModelLists: [],
          citys: [],
          joinType: "",
        },
        rules: {
          shopCode: {
            required: true,
            trrger: "blur",
            validator: patternLocation,
          },
          shopName: {
            required: true,
            trrger: "blur",
            message: "请输入商店名称",
          },
          employeeId: {
            required: true,
            trrger: "blur",
            message: "请选择商店联系人",
          },
          departInfoModelLists: {
            required: true,
            message: "请选择所属机构",
          },
          derportLists: {
            required: true,
            message: "请选择关联仓库",
          },
          isAccept: {
            required: true,
            trrger: "blur",
            message: "选择是否开启",
          },
          serviceStaff: {
            required: true,
            trrger: "blur",
            message: "请选择服务人员",
          },
          joinType: {
            required: true,
            trrger: "blur",
            message: "请选择是否是直营店",
          },
          shopPhone: [
            {
              required: true,
              validator: patternPhoneLocation,
              message: "请输入电话",
            },
          ],
        },
        mode2List: [],
        propCitys: {
          value: "value",
          children: "children",
        },
        props: {
          lazy: true,
          checkStrictly: true,
          lazyLoad: (node, resolve) => {
            const { level, data } = node;
            if (level === 0) {
              this.$store
                .dispatch("queryOrganizationTree", {
                  pageNo: 1,
                  pageSize: 999,
                  loginType: "store",
                })
                .then((res) => {
                  res.result.records.forEach((v) => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.id;
                    v.label = v.departName;
                  });
                  resolve(res.result.records);
                });
            } else {
              this.$store
                .dispatch("queryOrganizationListByParent", {
                  parentId: data.treeStruct,
                  loginType: "store",
                })
                .then((res) => {
                  if (res.code === "0" && res.result) {
                    res.result.forEach((v) => {
                      v.leaf = Boolean(!v.isParent);
                      v.value = v.id;
                      v.label = v.departName;
                    });
                    resolve(res.result);
                  } else {
                    resolve([]);
                  }
                });
            }
          },
        },
        thirdExpressInfoList: [],
        row: {},
        shopSetVisible: false,
        ruleFormShopSet: {
          showShopAddress: "open",
        },
        storeCode: "",
        detailVisible: false,
        payInfoList: []
      };
    },
    computed: mapGetters(["expressListAll"]),
    watch: {
    },
    created() {
      // this.getParamsCookie();
      this.queryAllThreeDelivery();
      this.queryServiceStaff();
    },
    mounted() {
      const { storeCode } = getLoginUser();
      this.storeCode = storeCode;
      this.queryList();
      this.queryStoreConfigAll();
      this.$store
        .dispatch("queryEmployee", {
          pageSize: 9999,
          workingState: "yes",
          loginType: "store",
        })
        .then((res) => {
          const result = res.result || {};
          if (res.code == 0) {
            this.employeeList = result.records;
            this.$store
              .dispatch("queryDepotListList", { pageSize: 10 })
              .then((res) => {
                const result = res.result || {};
                if (res.code == 0) {
                  this.depotList = result.records;
                }
              });
          }
        });
    },
    methods: {
      handleLocationSelect(loc) {
        if (this.dialogVisible) {
          this.ruleForm.shopAddress = loc.poiaddress;
          this.ruleForm.longitude = loc.longitude;
          this.ruleForm.dimension = loc.latitude;
        } else if (this.innerThreeVisible) {
          this.ruleFormThree.shopAddress = loc.poiaddress;
          this.ruleFormThree.longitude = loc.longitude;
          this.ruleFormThree.dimension = loc.latitude;
        }
      },
      // 保存
      handleSelectionChange (selectionArr) {
        this.$emit("getTheSelectedStore", selectionArr);
      },
      // 获取服务人员
      async queryServiceStaff() {
        const {code, result} = await this.$store.dispatch("getModelByParamCode", {
          paramCode:"storeShopInfo_attendant"
        });
        if(code == '0') {
          if(result){
            result.paramValue = JSON.parse(result.paramValue);
            this.theAttendantPullsDown = result.paramValue;
            // console.log(result.paramValue[0].staffName);
            this.ruleForm.serviceStaff = result.paramValue[0].staffName;
          }
        }
      },
  
      async saobeiConfigList() {
        const {code, result} = await this.$store.dispatch("saobeiConfigList", {
          shopId: this.row.shopId || this.shopId,
          pageNo: 1,
          pageSize: 10,
        });
        // console.log("---result---", result);
        if( code === '0' ) {
          this.payInfoList = result.records
        }
      },
      async showPayInfo() {
        await this.saobeiConfigList();
        this.detailVisible = true;
      },
      async queryAllThreeDelivery() {
        const { code, result } = await this.$store.dispatch(
          "queryThirdExpressInfoList"
        );
        if (code === "0") {
          this.thirdExpressInfoList = result;
        }
      },
      openThree() {
        if (this.threeDialogTitle === "查看三方平台信息") {
          this.queryThreeInfo();
          return;
        }
        this.innerThreeVisible = true;
      },
      async queryThreeInfo() {
        const { code, result } = await this.$store.dispatch(
          "queryThirdShopInfo",
          { shopId: this.row.shopId }
        );
  
        if (code === "0") {
          this.innerThreeVisible = true;
          for (let key in result) {
            if (this.ruleFormThree.hasOwnProperty(key)) {
              this.ruleFormThree[key] = result[key];
            }
          }
          this.ruleFormThree.citys = [
            this.ruleFormThree.shopProvinceCode,
            this.ruleFormThree.shopCityCode,
            this.ruleFormThree.shopDistrictCode,
          ];
        }
      },
      handleChange(file, fileList) {
        if (file.status === "ready") {
          this.loadProgress = 0;
          this.progressFlag = true;
          const interval = setInterval(() => {
            if (this.loadProgress >= 99) {
              clearInterval(interval);
            }
          }, 20);
        }
        if (file.status === "success") {
          this.loadProgress = 100;
          setTimeout(() => {
            this.progressFlag = false;
          }, 1000);
        }
      },
      handleChange2(file, fileList) {
        if (file.status === "ready") {
          this.loadProgress = 0;
          this.progressFlag2 = true;
          const interval = setInterval(() => {
            if (this.loadProgress >= 99) {
              clearInterval(interval);
            }
          }, 20);
        }
        if (file.status === "success") {
          this.loadProgress = 100;
          setTimeout(() => {
            this.progressFlag2 = false;
          }, 1000);
        }
      },
      // //文件上传时的钩子
      // uploadVideoProcess(event, file, fileList) {
      //   this.progressFlag = true; // 显示进度条
      //   this.loadProgress = parseInt(event.percent); // 动态获取文件上传进度
      //   if (this.loadProgress >= 100) {
      //     this.loadProgress = 100;
      //     setTimeout(() => {
      //       this.progressFlag = false;
      //     }, 1000); // 一秒后关闭进度条
      //   }
      // },
      // 正在上传
      uploading() {
        this.isSaving = true;
        this.uploadShow = true;
      },
      beforeAvatarUpload(file) {
        const extension =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
        const extension2 =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpeg";
        const extension3 =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
        const extension4 =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
        // file.size单位为b，除以1024得到kb
        // const limitSize = file.size / 1024 <= 100;
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
            type: "warning",
          });
        }
   
        return extension || extension2 || extension3 || extension4;
      },
      cropUploadSuccess(jsonData) {
        if (jsonData.code === 0) {
          this.ruleForm.shopImg = jsonData.result;
          this.uploadShow = false;
        }
      },
      cropUploadSuccess2(jsonData) {
        if (jsonData.code === 0) {
          this.ruleForm.qrCode = jsonData.result;
          this.uploadShow = false;
        }
      },
      // 上传错误
      uploadError() {
        this.$message({
          message: "上传失败，请重试!",
          type: "warning",
        });
        this.isSaving = false;
      },
      handleRemove() {
        this.ruleForm.shopImg = "";
      },
      handleRemove2() {
        this.ruleForm.qrCode = "";
      },
      ruleDistributionFormChange(val) {
        if (val === "all") {
          this.ruleDistributionForm.expressIds = [];
          this.checkedMicroRow = [];
        }
      },


      // 门店列表
      async queryList(state) {
        if(state == 'reset') {
          this.joinType='';
          this.keyWords='';
        }
        // this.setParamsCookie();
        if (typeof this.departId == "object") {
          this.departId = this.departId[this.departId.length - 1];
        }
        let {id} = this.checkOutTheStoreData;
        let params = {
          joinType: this.joinType,
          shopName: this.keyWords,
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          serviceProjectInfoId: id,
        };
        let url = "queryProjectInfoServiceShopPage";
        const { result } = await this.$store.dispatch(url, params);
        // console.log("门店列表", result);
        if(result){
          this.shopList = result;
        }

      },


      // setParamsCookie() {
      //   let searchCondition = {
      //     keyWords: this.keyWords,
      //     departId: this.departId,
      //     isAccept: this.isAccept,
      //   };
      //   setCookie({
      //     key: "queryShopListParams",
      //     type: "session",
      //     data: Object.assign({}, searchCondition, {
      //       pageSize: this.pageSize,
      //       currentPage: this.currentPage,
      //     }),
      //   });
      // },
      // getParamsCookie() {
      //   const prams = getCookie({ key: "queryShopListParams", type: "session" });
      //   if (prams) {
      //     this.keyWords = prams.keyWords;
      //     this.departId = prams.departId;
      //     this.isAccept = prams.isAccept;
      //     this.pageSize = prams.pageSize;
      //     this.currentPage = prams.currentPage;
      //   }
      // },
      paging(page) {
        this.currentPage = page;
        this.queryList();
      },
      handleSizeChange(size) {
        this.currentPage = 1;
        this.pageSize = size;
        this.queryList();
      },
      expressPaging(page) {
        this.expressCurrentPage = page;
        this.queryExpressList();
      },
      expressSizeChange(size) {
        this.expressCurrentPage = 1;
        this.expressPageSize = size;
        this.queryExpressList();
      },
      search() {
        this.currentPage = 1;
        this.queryList();
      },


      batchAffirm() {
        this.dialogAssignVisible = false;
      },
  
  
      async queryDetails() {
        const { code, result } = await this.$store.dispatch("queryByIdShop", {
          shopId: this.row.shopId,
        });
        if (code === "0") {
          for (let key in result) {
            if (this.ruleFormThree.hasOwnProperty(key)) {
              this.ruleFormThree[key] = result[key];
            }
          }
          this.ruleFormThree.citys = [
            this.ruleFormThree.shopProvinceCode,
            this.ruleFormThree.shopCityCode,
            this.ruleFormThree.shopDistrictCode,
          ];
        }
      },
      save() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            let ModelList = [];
  
            ModelList.push({
              id: this.ruleForm.departInfoModelLists[
                this.ruleForm.departInfoModelLists.length - 1
              ],
            });
  
            let derportList = [];
  
            this.ruleForm.derportLists.map((v) => {
              derportList.push({ depotId: v });
            });
            let params = this.ruleForm;
  
            // console.log("保存:", params);
  
            let serviceStaffJson = {};
            this.theAttendantPullsDown.forEach(item => {
              if(item.staffName == params.serviceStaff){
                serviceStaffJson = item;
              }
            })
            serviceStaffJson= JSON.stringify(serviceStaffJson);
            params.serviceStaffJson = serviceStaffJson;
  
            params.departInfoModelList = ModelList;
            params.derportList = derportList;
            if (params.citys.length) {
              params.shopProvinceCode = params.citys[0];
              params.shopCityCode = params.citys[1];
              params.shopDistrictCode = params.citys[2];
            }
            // console.log("params:", params);
            if (
              this.title === "添加商店信息" &&
              params.isAccept === "yes" &&
              params.joinType === "join"
            ) {
              this.$message({
                message: "加盟店没配置扫呗账户前不允许开启微店接单",
                type: "error",
              });
              return false;
            }
            this.$store
              .dispatch(
                this.title == "添加商店信息" ? "addShop" : "editShop",
                params
              )
              .then((res) => {
                if (res.code === "0") {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.dialogVisible = false;
                  setTimeout(() => {
                    this.resetRuleForm();
                  }, 0);
                  this.queryList();
                }
              });
          } else {
            return false;
          }
        });
      },
      submitFormThree(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let params = JSON.parse(JSON.stringify(this.ruleFormThree));
            if (params.citys.length) {
              params.shopProvinceCode = params.citys[0];
              params.shopCityCode = params.citys[1];
              params.shopDistrictCode = params.citys[2];
            }
            let name =
              this.threeDialogTitle === "查看三方平台信息"
                ? "editShopToDaDa"
                : "saveShopToDaDa";
  
            this.$store.dispatch(name, params).then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.$store
                  .dispatch("detailsShopaExpress", params)
                  .then((res) => {
                    if (res.code === "0") {
                      this.ruleDistributionForm.thirdCode = res.thirdCode;
                      this.ruleDistributionForm.thirdRelationId =
                        res.thirdRelationId;
                    }
                  });
                this.innerThreeVisible = false;
                this.ruleDistributionForm.isThreeDelivery = "yes";
                this.threeDialogTitle = "查看三方平台信息";
              }
            });
          } else {
            return false;
          }
        });
      },
      submitForm(ruleDistributionForm) {
        this.$refs[ruleDistributionForm].validate((valid) => {
          if (valid) {
            let params = this.ruleDistributionForm;
            params.shopId = this.shopId;
            if (params.expressAreaMode === "target") {
              params.expressIds = this.checkedMicroRow;
            }
  
            this.$store.dispatch("editExpressConfig", params).then((res) => {
              if (res.code === "0") {
                this.dialogDistributionVisible = false;
                this.queryList();
              }
            });
          } else {
            return false;
          }
        });
      },
      addAssign() {
        this.dialogAssignVisible = true;
        this.queryExpressList();
      },
      getMicroChecked(selection) {
        this.checkedMicroRow = selection.map((v) => v.expressId);
      },
      isArray(arr) {
        return Object.prototype.toString.call(arr) === "[object Array]";
      },
      queryExpressList() {
        let params = {
          pageNo: this.expressCurrentPage,
          pageSize: this.expressPageSize,
          enabledState: "yes",
        };
        return this.$store.dispatch("expressListAll", params).then((res) => {
          if (this.isArray(this.ruleDistributionForm.expressIds)) {
            setTimeout(() => {
              this.ruleDistributionForm.expressIds.forEach((v) => {
                res.result.records.map((row) => {
                  if (row.expressId === v) {
                    this.$refs.brandTable.toggleRowSelection(row, true);
                  }
                });
              });
            }, 0);
          }
        });
      },
      resetRuleForm() {
        this.$refs.ruleForm.resetFields();
        this.ruleForm = {
          shopCode: "",
          shopName: "",
          shopPhone: "",
          phone: "",
          remarks: "",
          derportLists: [],
          employeeId: "",
          serviceStaff:'',
          isAccept: "",
          shopAddress: "",
          shopDetailAddress: "",
          longitude: "",
          dimension: "",
          shopImg: "",
          qrCode: "",
          description: "",
          isShow: true,
          departInfoModelLists: [],
          citys: [],
          joinType: "",
        };
        this.ruleForm.remarks = "";
        this.ruleForm.employeeId = "";
        this.ruleForm.shopDetailAddress = "";
        this.$refs.cascader.presentText = "";
        this.ruleForm.qrCode = "";
        this.ruleForm.description = "";
        this.ruleForm.isShow = true;
        this.ruleForm.seqNum = "";
      },
      init(center, radius) {
        let overlaysArray = []; //覆盖物容器,用于清除覆盖物
        let points = "";
        var map;
        const { qq } = window;
        if (
          this.ruleDistributionForm.regionType === "circular" &&
          this.ruleDistributionForm.areaCodeCenter !== ""
        ) {
          let lat = +this.ruleDistributionForm.areaCodeCenter.split(",")[0];
          let lng = +this.ruleDistributionForm.areaCodeCenter.split(",")[1];
          let centers = new qq.maps.LatLng(lat, lng);
          map = new qq.maps.Map(document.getElementById("containers"), {
            center: centers,
            zoom: 14,
          });
  
          new qq.maps.Circle({
            map: map,
            center: centers,
            radius: +this.ruleDistributionForm.areaCodeRadius,
            strokeWeight: 5,
          });
        } else if (this.ruleDistributionForm.regionType === "polygon") {
          let list = JSON.parse(this.ruleDistributionForm.areaCodeRegion);
  
          map = new qq.maps.Map(document.getElementById("containers"), {
            center: new qq.maps.LatLng(list[0].lat, list[0].lng),
            zoom: 14,
          });
          var path = [];
          list.forEach((v) => {
            path.push(new qq.maps.LatLng(v.lat, v.lng));
          });
  
          new qq.maps.Polygon({
            map: map,
            path: path,
            editable: true,
            strokeWeight: 5,
          });
        } else {
          map = new qq.maps.Map(document.getElementById("containers"), {
            center: new qq.maps.LatLng(30.5993, 114.24831),
            zoom: 14,
          });
        }
     
        var drawingManager = new qq.maps.drawing.DrawingManager({
          drawingControl: true,
          drawingControlOptions: {
            position: qq.maps.ControlPosition.TOP_CENTER,
            drawingModes: [
           
              qq.maps.drawing.OverlayType.POLYGON,
          
            ],
          },
          circleOptions: {
            fillColor: new qq.maps.Color(255, 208, 70, 0.3),
            strokeColor: new qq.maps.Color(88, 88, 88, 1),
            strokeWeight: 3,
            clickable: false,
          },
        });
        drawingManager.setMap(map);
        qq.maps.event.addListener(drawingManager, "overlaycomplete", function(
          event
        ) {
          if (event.type == "circle") {
            clearOverlays(overlaysArray);
            overlaysArray.push(event.overlay);
            var latLng = event.overlay.getCenter();
            var newRadius = event.overlay.getRadius();
            let lat = latLng.getLat().toFixed(5);
            let lng = latLng.getLng().toFixed(5);
            var center = new qq.maps.LatLng(lat, lng);
            var geocoder = new qq.maps.Geocoder();
            geocoder.getAddress(latLng);
            //设置服务请求成功的回调函数
  
            geocoder.setComplete(function(result) {
              doMarker(center, result.detail.address + latLng);
              getPeopleDataByCircle(newRadius, lat + "," + lng);
            });
  
            //若服务请求失败，则运行以下函数
            geocoder.setError(function() {
              alert("出错了，请输入正确的经纬度！！！");
            });
          } else if (event.type == "polygon" || event.type == "rectangle") {
            clearOverlays(overlaysArray);
            overlaysArray.push(event.overlay);
  
            let list = [];
            event.overlay.getPath().forEach(function(e) {
              var lng = e.getLng().toFixed(6);
              var lat = e.getLat().toFixed(6);
              list.push({ lng: lng, lat: lat });
              points += lng + " " + lat + ",";
            });
  
            points = points.substring(0, points.length - 1);
            getPeopleDataByPolygon(JSON.stringify(list));
          }
        });
        //查询圆数据
        let that = this;
        function getPeopleDataByCircle(radius, center) {
          // alert("圆形中心为:" + center + "半径为:" + radius);
          that.ruleDistributionForm.regionType = "circular";
          that.ruleDistributionForm.areaCodeCenter = center;
          that.ruleDistributionForm.areaCodeRadius = radius;
        }
        //查询多边形数据
        function getPeopleDataByPolygon(points) {
          that.ruleDistributionForm.regionType = "polygon";
          that.ruleDistributionForm.areaCodeRegion = points;
        }
        //清除覆盖物
        function clearOverlays(overlaysArray) {
          if (overlaysArray) {
            overlaysArray.forEach((v, i) => {
              overlaysArray[i].setMap(null);
            });
          }
        }
        //画圆中心点
        function doMarker(center, title) {
          //创建一个Marker
          var marker = new qq.maps.Marker({
            //设置Marker的位置坐标
            position: center,
            //设置显示Marker的地图
            map: map,
            title: title,
          });
  
          //设置Marker的可见性，为true时可见,false时不可见，默认属性为true
          marker.setVisible(false);
          //设置Marker的动画属性为从落下
          marker.setAnimation(qq.maps.MarkerAnimation.DOWN);
          overlaysArray.push(marker);
          marker.setMap(map);
        }
      },
      async queryStoreConfigAll() {
        const { result } = await this.$store.dispatch("queryStoreConfigAll", {
          storeCode: this.storeCode,
          code: "shopSet",
        });
        // console.log("result:", result);
        if (result.value) {
          this.ruleFormShopSet = JSON.parse(result.value);
        } else {
          this.addStoreConfigAll();
        }
      },
      async addStoreConfigAll() {
        let value = JSON.stringify(this.ruleFormShopSet);
        const { result } = await this.$store.dispatch("addStoreConfigAll", {
          storeCode: this.storeCode,
          code: "shopSet",
          name: "新增商城配置",
          value: value,
        });
        // console.log("result:", result);
      },
      async editStoreConfigAll() {
        let value = JSON.stringify(this.ruleFormShopSet);
        const { result } = await this.$store.dispatch("editStoreConfigAll", {
          storeCode: this.storeCode,
          code: "shopSet",
          name: "编辑商城配置",
          value: value,
        });
        this.$message({
          type: "success",
          message: "设置成功",
        });
        this.queryStoreConfigAll();
      },
      // 提交
      saveShopSet(formName) {
        this.editStoreConfigAll();
      },
      openShopSet() {
        this.shopSetVisible = true;
      },
    },
  };
  </script>
 
  <style lang="scss">
  .avatar-uploader {
    .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 360px;
      height: 180px;
      line-height: 180px;
      text-align: center;
    }
  }
  </style>
  <style lang="scss" scoped>
  .priview {
    position: relative;
    width: 360px;
    height: 180px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    img {
      width: 100%;
      height: 100%;
    }
    .opreat-wrapper {
      transition: opacity 0.2s linear;
      position: absolute;
      opacity: 0;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 6px;
    }
  
    &:hover {
      .opreat-wrapper {
        opacity: 1;
      }
    }
  }
  .title {
    &::before {
      display: inline-block;
      margin-right: 5px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
  .ruleFormShopSet {
    .tips {
      color: #999999;
    }
  }
  .ml10 {
    margin-left: 10px;
  }
  </style>
  